import * as styles from './continue-button.css';

import { Box, Button, CircularProgress } from '@mui/material';

type ContinueButtonProps = (React.ComponentProps<typeof Button> &
  React.ComponentProps<typeof Box>) & {
  loading?: boolean;
};

const ContinueButton = ({ loading, children = 'Continue', ...props }: ContinueButtonProps) =>
  loading ? (
    <span className={styles.noButton} {...props}>
      <CircularProgress />
    </span>
  ) : (
    <Button className={styles.button} disabled={loading} fullWidth variant="contained" {...props}>
      {children}
    </Button>
  );

export default ContinueButton;
